// A form's public web link (public-form plan §4, T24): <base>/f/<public_id>.
// REACT_APP_PUBLIC_FORMS_URL overrides the base (the staging admin sites
// point it at the staging web host); spaces and trailing slashes are
// dropped. Otherwise the platform picks the canonical www host; like the rest
// of the admin, anything that isn't tickethoss or kartpass is Pit Pay. Kart
// Pass has no web form, so there is no link. Read at call time so tests can
// switch the env per case (like brand.js).

export const publicFormBase = () => {
  const override = (process.env.REACT_APP_PUBLIC_FORMS_URL || '')
    .trim()
    .replace(/\/+$/, '');
  if (override) return override;
  const platform = process.env.REACT_APP_PLATFORM;
  if (platform === 'kartpass') return null;
  if (platform === 'tickethoss') return 'https://www.tickethoss.com';
  return 'https://www.pitpay.com';
};

export const publicFormUrl = (publicId) => {
  const base = publicFormBase();
  return base && publicId ? `${base}/f/${publicId}` : null;
};

export default publicFormUrl;
